const colors = [
  "White",
  "Black",
  "Gray",
  "Silver",
  "Red",
  "Blue",
  "Brown",
  "Green",
  "Beige",
  "Orange",
  "Gold",
  "Yellow",
  "Purple",
];

export default colors;
